import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Store } from '@ngxs/store'
import { AppState } from '../state/app.state'

/**
 * Loggt HttpFehler im ErrorCenterService.
 */
export function auditInterceptorFn(): HttpInterceptorFn {
  return (req, next) => {
    const { auditId } = inject(Store).selectSnapshot(AppState.getState)
    if (auditId) {
      req = req.clone({
        headers: req.headers.set('X-Audit-ID', auditId),
      })
    }
    return next(req)
  }
}
